import {NormalizedForecastModel} from '../../utils/Forecast/types';

export const resolveSelectedForecastModel = <K extends string | number>(
  forecastModelList: NormalizedForecastModel[],
  selectedForecastModelKeyDict: Record<K, string>,
  forecastModelOrder: string[] | null,
  id: K,
): NormalizedForecastModel | undefined => {
  if (id in selectedForecastModelKeyDict) {
    const overrideKey = selectedForecastModelKeyDict[id];
    return forecastModelList.find((item) => item.key === overrideKey);
  }
  if (forecastModelOrder) {
    for (const key of forecastModelOrder) {
      const match = forecastModelList.find((item) => item.key === key);
      if (match) {
        return match;
      }
    }
  }
  return forecastModelList.find((item) => item.key === 'GFS');
};
